import React from 'react'
import { createRoot } from 'react-dom/client'
import { AppBrowser } from './AppBrowser'
import { AppOpenFin } from './AppOpenFin'
import { isOpenFin } from 'utils'
import ErrorScreen from 'view/shared/error/ErrorScreen'
import './view/styles/global'
import { QUOTE_APP_BASE_URL } from './constants'

console.log(`BrokerTecQuote application started, build ${BUILD_COMMIT} ${new Date(BUILD_TIME).toISOString()}`)

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Element #root not found')
}

const root = createRoot(rootElement)

try {
  if (isOpenFin()) {
    root.render(<AppOpenFin />)

    // For some reason the React component does not get unmounted when a window is closed,
    // and this means that there are stale subscriptions to the redux store. Force the unmount.
    const currentWindow = fin.desktop.Window.getCurrent()
    currentWindow.addEventListener('close-requested', () => {
      root.unmount()
      currentWindow.close(true)
    })
  } else {
    root.render(<AppBrowser />)
  }

  // from v6 and on react-router doesn't redirect on it's own to baseUrl
  // this statement forces the same behavior as before
  // so if a user types qa.quote.brokertec.com will be redirected to qa.quote.brokertec.com/quote
  if (!window.location.pathname.includes(QUOTE_APP_BASE_URL)) {
    window.history.replaceState('', '', QUOTE_APP_BASE_URL + window.location.pathname)
  }
} catch (error) {
  root.render(<ErrorScreen error={error} closeApp={true} />)
}
